import styled, { css } from 'styled-components';
import { palette } from '../../theme/colors';
import { toRem } from '../../utils/toRem';

export const SOverLay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
`;
export const SModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export const SDialog = styled.div`
  z-index: 100;
  background: ${palette.prussianBlue2};
  position: relative;
  margin: 10rem auto;
  border-radius: 3px;
  width: 23rem;
  padding: 30px 20px;
  text-align: center;
  font-family: 'Roboto-Regular';

  box-shadow: 0px 11px 15px rgba(90, 90, 90, 0.1);
  backdrop-filter: blur(21.7463px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 5px;
`;
export const STitle = styled.p`
  font-size: 18px;
  font-family: 'Roboto-Medium';
  font-weight: 500;
  margin-bottom: 1rem;
  color: ${palette.white};
`;

export const SDescription = styled.p<{
  descriptionStyle?: 'fit-big-text';
}>`
  color: ${palette.white};
  word-wrap: ${props => (props.descriptionStyle === 'fit-big-text' ? 'break-word' : 'normal')};
`;

export const SButtonWrapper = styled.div<{ $haveError?: boolean }>`
  display: flex;
  margin-top: ${props => (props.$haveError ? '1rem' : '1.5rem')};
  justify-content: space-evenly;
  width: 100%;
  gap: 1rem;
`;

const SButton = styled.button`
  cursor: pointer;
  font-family: 'Roboto-Medium';
  font-size: 16px;
  height: 45px;
  min-width: 7.5rem;
  padding: 0 2rem;
  border: 0;
  border-radius: 25.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const SCancelButton = styled(SButton)`
  color: ${palette.white};
  background-color: transparent;
  border: 1px solid ${palette.honeyYellow};
`;

export const SConfirmButton = styled(SButton)<{
  confirmStyle?: 'standard' | 'green' | 'red' | 'fit-big-text';
  $disabled?: boolean;
}>`
  color: ${props =>
    props.confirmStyle === 'green'
      ? palette.white
      : props.confirmStyle === 'red'
        ? palette.white
        : palette.raisinBlack3};

  background-color: ${props =>
    props.confirmStyle === 'green'
      ? palette.applGreen
      : props.confirmStyle === 'red'
        ? palette.tartOrange
        : palette.honeyYellow};

  opacity: ${props => (props.$disabled ? 0.5 : 1)};

  ${props =>
    props.confirmStyle === 'fit-big-text' &&
    css`
      padding: 0 0.7rem;
    `}
`;

export const SError = styled.p`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: ${toRem(13)};
  margin-top: ${toRem(10)};
  color: ${palette.tartOrange};
`;
